var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-showcase-page"},[_c('ProductShowcase',{on:{"buy-now":_vm.handleBuyNow,"learn-more":_vm.handleLearnMore,"product-selected":_vm.handleProductSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }